import request from "utils/request";

/**
 *报名企业培训 POST
 *
 * @export
 * @param {object} data
 * Match
 * @returns
 */
export function signUpTrain(data) {
  return request({
    url: "/Train/SignUp",
    method: "post",
    data
  });
}
/**
 * 增加培训浏览量
 *
 * @export
 * @param {object} param
 *
 * @returns
 */
export function trainAddViewCount(params) {
  return request({
    url: "/Train/AddViewCount",
    method: "post",
    params
  });
}

/**
 *岗位实践报名 POST
 *
 * @export
 * @param {object} data
 * Match
 * @returns
 */
export function signUpJob(data) {
  return request({
    url: "/Job/SignUp",
    method: "post",
    data
  });
}

/**
 * 增加岗位浏览量
 *
 * @export
 * @param {object} param
 *
 * @returns
 */
export function jobAddViewCount(params) {
  return request({
    url: "/Job/AddViewCount",
    method: "get",
    params
  });
}
